module.exports = __webpack_public_path__ + "img/Cloud error Icon - charcoal.3db63f62.svg";